import React from 'react';
import { connect } from 'react-redux';
import HomepageBuilder from './HomepageBuilder';
import ErrorBoundary from './ErrorBoundary';
import privateView from '../../components/hocs/privateView';

const mapStateToProps = ({ auth: { isFetch, isLogged, roles, id, email } }) => ({
  guardData: { isFetch, isLogged, roles, id, email },
});

// Bind the platform per route, gate with privateView (defaults to superadmin/admin — same as Settings).
function makeBuilder(platform) {
  const Inner = (props) => <ErrorBoundary><HomepageBuilder {...props} platform={platform} /></ErrorBoundary>;
  return connect(mapStateToProps)(privateView(Inner));
}

export const HomepageBuilderWeb = makeBuilder('web');
export const HomepageBuilderApp = makeBuilder('app');
